import type { SiteDocument } from "@twm/shared";

/** Map image fields only, never arbitrary text, links or instructions. */
export function mapDemoSiteImages(site: SiteDocument, mapper: (value: string) => string): SiteDocument {
  const image = (value?: string) => value ? mapper(value) : value;
  return { ...site, logo: image(site.logo), favicon: image(site.favicon), pages: site.pages.map(page => ({ ...page, sections: page.sections.map(section => section.type === "hero" || section.type === "about" ? { ...section, image: image(section.image) } : section.type === "gallery" ? { ...section, images: section.images.map(item => ({ ...item, url: mapper(item.url) })) } : section) })) };
}

/** Local upload bytes are NOT sent to text AI. Restore their unique references afterwards. */
export function demoAiInput(site: SiteDocument) {
  const restore = new Map<string, string>();
  const references = new Map<string, string>();
  const safe = mapDemoSiteImages(site, value => {
    if (!value.startsWith("data:image/")) return value;
    let reference = references.get(value);
    if (!reference) { reference = `https://demo.trykate.invalid/draft/${references.size}`; references.set(value, reference); restore.set(reference, value); }
    return reference;
  });
  return { site: safe, restore };
}

/** Demo-only data URLs stay on the laptop. Production documents retain URL length limits. */
export function demoValidationSite(site: SiteDocument): SiteDocument {
  const imageUrl = (value?: string) => value?.startsWith("data:image/") && /^data:image\/(?:jpeg|png|webp|gif);base64,[A-Za-z0-9+/]+=*$/.test(value)
    ? "https://demo.local/image" : value;
  return {
    ...site, logo: imageUrl(site.logo), favicon: imageUrl(site.favicon),
    pages: site.pages.map(page => ({
      ...page, sections: page.sections.map(section => section.type === "hero" || section.type === "about" ? { ...section, image: imageUrl(section.image) }
        : section.type === "gallery" ? { ...section, images: section.images.map(image => ({ ...image, url: imageUrl(image.url)! })) } : section)
    }))
  };
}
